if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.setupCustomizationOptions(); // ⬅️ Añadido aquí
      }

      setupCustomizationOptions() {
        const customizationInput = this.form.querySelector('#customization-selection');
        if (!customizationInput) return;

        const tabs = this.form.querySelectorAll('.tab');
        const optionContainers = this.form.querySelectorAll('.option-container');
        const currentSelectionDisplay = this.form.querySelector('#current-selection');
        const customizationNotice = this.form.querySelector('#customization-notice');

        const symbolNames = {
          'corazon': '❤️ Corazón',
          'flor': '🌷 Flor',
          'huella': '🐾 Huella',
          'infinito': '∞ Infinito',
          'mariposa': '🦋 Mariposa',
          'paz': '☮️ Paz',
          'liso': 'Sin personalización'
        };

        const translations = {
          es: {
            none: 'Ninguna',
            number: 'Número ',
            letter: 'Letra ',
            symbol: 'Símbolo: ',
            plain: 'Liso'
          },
          en: {
            none: 'None',
            number: 'Number ',
            letter: 'Letter ',
            symbol: 'Symbol: ',
            plain: 'Plain'
          }
        };

        const lang = document.documentElement.lang === 'es' ? 'es' : 'en';

        tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('active'));
            optionContainers.forEach(c => c.classList.remove('active'));
            tab.classList.add('active');
            const target = this.form.querySelector(`#${tab.dataset.tab}`);
            if (target) target.classList.add('active');
          });
        });

        optionContainers.forEach(container => {
          container.addEventListener('click', (e) => {
            const option = e.target.closest('.option');
            if (!option) return;

            optionContainers.forEach(c => {
              c.querySelectorAll('.option').forEach(opt => opt.classList.remove('selected'));
            });

            option.classList.add('selected');
            const selectedValue = option.getAttribute('data-value');
            const tabName = container.id;

            let displayValue = '';
            switch(tabName) {
              case 'liso':
                displayValue = translations[lang].plain;
                break;
              case 'numero':
                displayValue = translations[lang].number + selectedValue;
                break;
              case 'letra':
                displayValue = translations[lang].letter + selectedValue;
                break;
              case 'simbolo':
                displayValue = translations[lang].symbol + (symbolNames[selectedValue] || selectedValue);
                break;
            }

            customizationInput.value = displayValue;
            if (currentSelectionDisplay) currentSelectionDisplay.textContent = displayValue || translations[lang].none;
            if (customizationNotice) customizationNotice.style.display = 'block';
          });
        });

        // seleccionar liso por defecto
        const plainOption = this.form.querySelector('#liso .option');
        if (plainOption) plainOption.click();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

